export interface GalleryImage {
  id: number;
  url: string;
  alt: string;
  rotation: number;
}

export const galleryImages: GalleryImage[] = [
  {
    id: 1,
    url: "/assets/rug.png",
    alt: "Modern barbershop interior with classic chairs and elegant decor",
    rotation: -3
  },
  {
    id: 2,
    url: "/assets/tee.png",
    alt: "Barber trimming client's beard with professional tools",
    rotation: 2
  },
  {
    id: 3,
    url: "/assets/powder-spray.png",
    alt: "Classic haircut in progress with attention to detail",
    rotation: -2
  },
  {
    id: 4,
    url: "/assets/clippers.png",
    alt: "Modern fade haircut showcasing precision barbering",
    rotation: 4
  },
  {
    id: 5,
    url: "/assets/towels.png",
    alt: "Stylist working on a client's hair with professional equipment",
    rotation: -4
  },
  {
    id: 6,
    url: "/assets/hair-drops.png",
    alt: "Hair styling session demonstrating expert technique",
    rotation: 3
  }
];